import { Component, OnInit, Inject, OnDestroy  } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SseService } from 'src/app/services/SseService';
import { CookieService } from 'ngx-cookie-service';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import { GestionService } from 'src/app/services/gestion.services';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-eliminarope-dialog',
  templateUrl: './eliminarope-dialog.component.html',
  styleUrl: './eliminarope-dialog.component.scss'
})
export class EliminaropeDialogComponent implements OnInit {

  public operacion: any;
  public isOpeValid: boolean=false;
  public isBroker: boolean=false;
  token: any;
  theme: any;

  constructor(public dialogRef: MatDialogRef<EliminaropeDialogComponent>,
    private _gestionsv: GestionService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _sseservice: SseService,
    private toastr: ToastrService,
    private cookieService : CookieService
){

  }


  ngOnInit(): void {
    this.operacion = this.data.operacion;
    console.log("ESTAS ES LA OPERACION QUE ELLGA", this.operacion )
    this.token = this.data.token;
    this.isBroker = !!this.data.broker;
    this.operacionValida();
    this.theme = localStorage.getItem('theme') || 'light-theme';
  }

  operacionValida(){
    if(this.operacion.tipoOperacion == 'ENTRADA ↓' || this.operacion.tipoOperacion == 'SALIDA ↓' || this.operacion.tipoOperacion == 'ENTRADA ↑' || this.operacion.tipoOperacion == 'SALIDA ↑' ){
      this.isOpeValid=true;
      console.log("ENTRO EN LAS this.operacion.tipoOperacion == 'ENTRADA ↓' || this.operacion.tipoOperacion == 'SALIDA ↓'");
    }else { 
      this.isOpeValid=false 
    }
  }

  cancelar(){
    this.dialogRef.close(false);
  }

  removeAfterSpace(input: string): string {
    return input.split(' ')[0];
  }

  eliminar(){
    console.log("ENTRAMOS EN ELIMINAR", this.token );
    this.operacion.tipoOperacion = this.removeAfterSpace(this.operacion.tipoOperacion);
    this._sseservice.apiPostNew('eliminaroperacion', this.operacion,this.token).subscribe({
      next: (data:any)=>{
        console.log("this._sseservice.apiPostNew('eliminaroperacion', this.operacion,this.token).subscribe",data);
        
        if (data && data.status) {
          this.toastr.success(data.msj, 'OK', { timeOut: 5000, positionClass: 'toast-top-center' });
        } else {
          this.toastr.error(data ? data.msj : 'Error', 'Error', { timeOut: 5000, positionClass: 'toast-top-center' });
        }
        this.dialogRef.close(data.status);
      }
    });
    //this.dialogRef.close(true);
  }

}
